import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { login02, logo } from '../../imagepath';
import { APP_NAME } from '../../../constants/constants';
import { forgotPassword } from '../../../api/auth.api';
import { translateError } from '../../../utils/errorTranslations';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const response = await forgotPassword({ email });
            setSuccess(true);
            // Redirect to reset password page after 2 seconds
            setTimeout(() => {
                navigate('/reset-password', { state: { email } });
            }, 2000);
        } catch (err) {
            const message = err?.data?.error || err?.data?.message || 'Failed to send reset code';
            setError(translateError(message));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <div className="main-wrapper login-body">
                <div className="container-fluid px-0">
                    <div className="row">
                        {/* Login logo */}
                        <div className="col-lg-6 login-wrap">
                            <div className="login-sec">
                                <div className="log-img">
                                    <img
                                        className="img-fluid"
                                        src={login02}
                                        alt="Logo"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* /Login logo */}
                        {/* Login Content */}
                        <div className="col-lg-6 login-wrap-bg">
                            <div className="login-wrapper">
                                <div className="loginbox">
                                    <div className="login-right">
                                        <div className="login-right-wrap">
                                            <div className="account-logo">
                                                <Link to="/login" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                                    <img src={logo} width="50" height="50" alt=""/>
                                                    <span style={{ marginLeft: '15px', fontSize: '28px', fontWeight: '500', color: '#2e37a4' }}>{APP_NAME}</span>
                                                </Link>
                                            </div>
                                            <h2>Възстановяване на парола</h2>
                                            <p style={{ marginBottom: '20px', color: '#6c757d' }}>
                                                Въведете вашия имейл адрес и ще ви изпратим код за възстановяване на паролата.
                                            </p>

                                            {success && (
                                                <div className="alert alert-success" role="alert">
                                                    Кодът за възстановяване е изпратен на вашия имейл. Пренасочване към страницата за нулиране...
                                                </div>
                                            )}

                                            {error && (
                                                <div className="alert alert-danger" role="alert">
                                                    {error}
                                                </div>
                                            )}

                                            {/* Form */}
                                            <form onSubmit={handleSubmit}>
                                                <div className="form-group">
                                                    <label>
                                                        Имейл <span className="login-danger">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="email"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required
                                                        disabled={isLoading || success}
                                                        placeholder="your@email.com"
                                                    />
                                                </div>
                                                <div className="form-group login-btn">
                                                    <button
                                                        className="btn btn-primary btn-block"
                                                        type="submit"
                                                        disabled={isLoading || success}
                                                    >
                                                        {isLoading ? 'Изпращане...' : 'Изпрати код за възстановяване'}
                                                    </button>
                                                </div>
                                            </form>
                                            {/* /Form */}
                                            <div className="next-sign">
                                                <p className="account-subtitle">
                                                    Спомнихте си паролата? <Link to="/login">Вход</Link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Login Content */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword;
